import { render, staticRenderFns } from "./PageKAction.vue?vue&type=template&id=a7a9380c"
import script from "./PageKAction.vue?vue&type=script&lang=js"
export * from "./PageKAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports